'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var callBind = {exports: {}};

exports.callBind = callBind;
